<template>
  <div id="app">
 		<transition :name="transitionName">
			<keep-alive><router-view v-if="this.$route.name === 'Home'"></router-view></keep-alive>
		</transition>
		<transition :name="transitionName">
			<router-view v-if="this.$route.name != 'Home'"></router-view>
		</transition>
    <transition name="fade">
	
    <!-- <img v-if="show_service" src="./assets/images/expert_consultant.png" class="expert_consultant" alt="" @click="linkGo('https://www.uniskin.com.cn/kefu/Index/index/mobile/from/report?from2=199', (actParams = { query: $route.query, pageid: 351 }),{report_type:'199基因',first_module:'咨询'})"> -->
		</transition>
  </div>
</template>


<script>
import axios from "axios";
// import sensors from "sa-sdk-javascript";
var wx = require("weixin-js-sdk");
export default {
  name: "App",
  data() {
    return {
      transitionName: "",
      in_weapp: false, //是否在小程序
      searchBarFixed: false,
      show_service:true,
      scroll_top:0
    };
  },
  watch: {
    // 		$route(to, from) {
    // 			if (to.meta.index > from.meta.index) {
    // 				this.transitionName = 'slide-left';
    // 			} else {
    // 				this.transitionName = 'slide-right';
    // 			}
    // 		}

    $route(to,from){
      
      if(this.$route.path == '/share'){
        this.show_service=false
      }else{
        this.show_service = true;
      }
    }
  },
  created() {
    console.log("App created");
    // this.checkStatus();
    // if(!(localStorage.getItem('uniskinmall_uid') || '')) localStorage.clear();
  },
   mounted: function() {
    var ua = navigator.userAgent.toLowerCase(),
      that = this;
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          console.log("在小程序里");
          that.in_weapp = true;
        }
      });
    }
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed: function() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    checkStatus:function(){
          this.$jsonp(
            "https://www.uniskin.com.cn/reportv2/index/gene_july_one/index"
          )
          .then(json => {
            console.log('status',json);
            if(json.code == 100){
               alert("请先登录");
          location.href = "https://www.uniskin.com.cn/mall/member/account/login";
            }
           
          })
          .catch(err => {
            console.log(err);
            localStorage.clear();
            location.href =
              "https://www.uniskin.com.cn/mall/member/account/login";
          });
    },
    // 复制成功
    onCopy(e) {
      console.log(e);
    },
    // 复制失败
    onError(e) {
      alert("失败");
    },
    handleScroll() {
      var scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop,
        offsetTop = window.innerHeight; //document.querySelector('#searchBar').offsetTop;
        this.scroll_top = scrollTop;
        // if((scrollTop >= 60) && (this.$route.path =='/')){
        //     this.show_service = true;
        // }else if((scrollTop < 60) && (this.$route.path =='/') || (this.$route.path == '/share')){
        //     this.show_service = false;
        // }else{
        //   this.show_service = true;
        // }
        console.log(scrollTop);
      // if (scrollTop > offsetTop / 2) {
      //   this.searchBarFixed = true;
      // } else {
      //   this.searchBarFixed = false;
      // }
    },
 

    goBack: function() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    linkGo: function(url, actParams, trackData) {
      // @click="$parent.linkGo('http://...', (actParams = { query: $route.query, pageid: 99 }))"
      // console.log('linkGo', url, actParams);
      if (actParams) this.actionLog(actParams);
      if (trackData) this.LFEvent(trackData);
      setTimeout(function(){
        location.href = url;
      },500);
    },
    routerGo: function(path, actParams, trackData) {
      // console.log(11, 'routerGo', path, actParams);
      // @click="$parent.routerGo('/history/pheno', (actParams = { query: $route.query, pageid: 99 }))"
      if (trackData) this.LFEvent(trackData);

      if (actParams) {
        this.$router.push({ path: path, query: actParams.query });
        this.actionLog(actParams);
      } else {
        this.$router.push({ path: path });
      }
    },
      goMallDetail: function(pid) {
        // sensors.track('reportEvent',{is_access:true,page_id:'472',page_name:'报告商品跳转到商品页',report_type:'199基因',first_module:'报告到商品页'});
        // window.linkflow.sendEvent({"reportEvent":{is_access:true,reportEvent_page_id:'472',reportEvent_page_name:'报告商品跳转到商品页',reportEvent_report_type:'199基因',reportEvent_first_module:'报告到商品页'}});
      if (this.in_weapp) {
        
        wx.miniProgram.navigateTo({
          url: "/mall-detail/mall-detail?scene=" + pid
        });
      } else {
        location.href =
          "https://www.uniskin.com.cn/homepage/m/pro_detail.html?p=" + pid;
      }
    },
    goPromotion: function(pro) {
      if (this.in_weapp) {
        wx.miniProgram.navigateTo({
          url: "/channel-mall-detail/channel-mall-detail?scene=" + pro
        });
      } else {
        location.href =
          "https://www.uniskin.com.cn/homepage/m/shop.html";
      }
     
    },
    goHome: function(){
      if (this.in_weapp) {
        wx.miniProgram.switchTab({
          url: "/mall/mall"
        });
      } else {
        location.href =
          "https://www.uniskin.com.cn/homepage/m/shop.html";
      }
    },
    trackLog:function(actParams,trackData){
       if (actParams) this.actionLog(actParams);
      if (trackData) this.LFEvent(trackData);
    },
    LFEvent: function(trackData) {
      console.log(trackData);
      //神策事件追踪
      
      // if (trackData){window.linkflow.sendEvent({"reportEvent":trackData})};
        // sensors.track('reportEvent',trackData);
    },
    actionLog: function(actParams) {
      // actParams = { query: $route.query, pageid: 1}
      let m = actParams.query.m || null,
        pageid = actParams.pageid || null;
      if (m && pageid)
        return axios.get("/mall/member/reportV2/actionlog", {
          params: { m, pageid }
        });
    }
  }
};
</script>


<style lang="less">
@import "https://static.inertiabiotech.com/uniskin/reportv3/css/adapter.css";
body{
  background:#f9f8f8!important;
}
.expert_consultant{
  position:fixed;
  width:1.92rem;
  height:1.92rem;
  bottom:2.8rem;
  right:0.72rem;
  z-index:9999;
  border-radius:50%;
  -webkit-box-shadow:3px 3px 10px 1px rgba(255,124,91,0.87);
  box-shadow:3px 3px 10px 1px rgba(255,124,91,0.87);
}
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 300ms;
  /* position: absolute; */
}
.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.progress {
  transition: all 0.3s;
}
.extend_box {
  overflow: hidden;
  transition: all 0.3s;
}

// #app {
//   font-family: "Avenir", Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
//   text-align: center;
//   color: #2c3e50;
// }
// #nav {
//   padding: 30px;
//   a {
//     font-weight: bold;
//     color: #2c3e50;
//     &.router-link-exact-active {
//       color: #42b983;
//     }
//   }
// }
</style>
